import { Button, ButtonGroup, ButtonGroupItem , Breadcrumb } from '@boozallen-uip/uswds-react-core';
import React, { useContext, useState, useEffect } from "react";
import tw from 'tailwind-styled-components';
import { PageSubHeader, SectionContainer, SectionSubHeader, SectionSubTitle } from '../shared.styled';
import HowTo from '../../components/HowTo.component';
import ExternalLinkIcon from '../../components/ExternalLinkIcon.component';
import { UserContext } from "../UserContext";
import isTokenValid from "../../utlities/auth.utility";
import PageHeader from '../../components/PageHeader/PageHeader.component';
import image1 from '../../assets/section-images/4500484cb61fc9e8b2b4e0c864a017b4.jpeg';
import image2 from '../../assets/section-images/c4ff41d6b41a9933462a094eea587413.jpeg';
import { BASE_TITLE, HOME_URL, FOR_VENDORS_URL } from '../../utlities/core.constants';
import { useLoginModal } from '../../components/modals/LoginModalContext';

const SectionWrapper = tw.div`flex ${props => props.reversed ? "flex-row-reverse" : "flex-row"} items-start mb-8`;
const ImageWrapper = tw.div`basis-1/3 [&>img]:h-[252px] ${props => props.reversed ? "ml-6" : "mr-4"}`;
const Wrapper = tw.div`flex flex-1 flex-col`;

export default function ForVendors() {
  // const { user, setJwt } = useContext(UserContext);
  const [isAuthenticated, setIsAuthenticated] = useState();
  const { token } = useContext(UserContext);
  const { openLoginModal, isLoginModalOpen } = useLoginModal();
  // eslint-disable-next-line class-methods-use-this
  document.title = `${BASE_TITLE} - For Vendors`;
  useEffect(() => {
    setIsAuthenticated(isTokenValid(token))
  }, [token])

  return <div>

    <PageHeader imageUrl="/page-banners/VendorBannerImg.png" backgroundSize='1200px 180px' backgroundPosition='right' backgroundColor="var(--color-primary)">
      ACR Repository for Vendors
    </PageHeader>
    <SectionContainer>
      <div className='text-primary-darker'>
        <Breadcrumb links={[{"href": HOME_URL, "text": "Home"}, {"href": FOR_VENDORS_URL, "text": "For Vendors"}]} />
      </div>
      <div>
        <PageSubHeader>ACR Repository helps your customers find the information they need</PageSubHeader>
        <SectionSubHeader className='font-normal'>ACRs boost vendor credibility and user trust, while promoting product accessibility.</SectionSubHeader>
        <p className='leading-normal'>
          Accessibility Conformance Reports (ACRs) enhance transparency, build trust, and improve user experience,
          particularly for people with disabilities. ACRs detail a product&apos;s accessibility features and conformance
          to accessibility standards like the Web Content Accessibility Guidelines (WCAG) and Section 508, aiding users
          in informed purchasing decisions. These reports signal a vendor’s commitment to inclusivity, fostering loyalty
          among users who value accessible design. ACRs encourage better product designs through universal design principles,
          making technology usable for a broader audience and spurring innovation. They can also serve as a feedback mechanism,
          allowing continuous product improvement.
        </p>
      </div>
      <div>
        {isAuthenticated ? null :
          <ButtonGroup>
            <ButtonGroupItem>
              <Button onClick={openLoginModal} aria-haspopup="dialog" aria-controls="login-modal" aria-expanded={isLoginModalOpen}>Log in to your dashboard</Button>
            </ButtonGroupItem>
          </ButtonGroup>}
      </div>
      <div>
        <SectionSubHeader>Why add your products to the ACR Repository</SectionSubHeader>
        <SectionWrapper>
          <ImageWrapper>
            <img alt="" aria-hidden="true" className='object-cover' src={image1} />
          </ImageWrapper>
          <Wrapper>
            <SectionSubTitle className='mt-0'>Increased Transparency</SectionSubTitle>
            <div className='leading-normal'>An Accessibility Conformance Report (ACR) explains how information and communication technology (ICT) products—such as software, hardware, electronic content, and support documentation—meet the <a href="https://www.access-board.gov/guidelines-and-standards/communications-and-it/about-the-ict-refresh/final-rule" target="_blank" rel="noopener noreferrer">Revised 508 Standards<ExternalLinkIcon /><span className="usa-sr-only"> (opens in new window)</span></a> for IT accessibility. ACRs help Federal agency contracting officials and government buyers to assess ICT for accessibility when doing market research and evaluating proposals. In turn, procurement personnel are able to make informed decisions using the enhanced transparency ACRs provide, resulting in an improved customer experience.</div>
          </Wrapper>
        </SectionWrapper>
        <SectionWrapper reversed className='mb-0'>
          <ImageWrapper reversed>
            <img alt="" aria-hidden="true" className='object-cover' src={image2} />
          </ImageWrapper>
          <Wrapper>
            <SectionSubTitle className='mt-0'>Improves Trust and Satisfaction</SectionSubTitle>
            <div className='leading-normal'>ACRs promote accuracy in accessibility reporting and drive quality improvements in products. They also show customers that accessibility requirements are taken seriously by the company, and help subject matter experts provide meaningful input during the procurement process. Making these reports easy to find helps procurement personnel feel comfortable in the fact that accessibility was taken into account when making purchasing decisions.</div>
          </Wrapper>
        </SectionWrapper>
      </div>
    </SectionContainer>
    <div className="bg-no-repeat bg-right bg-secondary-lighter bg-contain bg-[url('../assets/howtobackground.svg')] -mx-12">
      <SectionContainer>
        <HowTo />
      </SectionContainer>
    </div>
  </div>
}
